 <div class="col-12 footer">
        <div>
            <div>
                <button type="button" [disabled]="disabled" class="btn btn-outline-danger btn-square px-5 mr-1" (click)="onCancelClick.emit()">
                    {{'Cancel' | localize}}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary btn-square px-8"  [disabled]="disabled" (click)="onSaveClick.emit()">
                    {{'Save' | localize}}
                </button>
            </div>
        </div>
    </div>
